// extracted by mini-css-extract-plugin
export default {"hideTooltip":"T9-z","fadeIn":"U9-z","delay":"V9-z","recommendedSizeTooltip":"W9-z"};